import { render } from "./ProjectFilmsList.vue?vue&type=template&id=5f552129&scoped=true"
import script from "./ProjectFilmsList.vue?vue&type=script&lang=js"
export * from "./ProjectFilmsList.vue?vue&type=script&lang=js"

import "./ProjectFilmsList.vue?vue&type=style&index=0&id=5f552129&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f552129"]])

export default __exports__